<template>
  <app-modal
    v-bind="$attrs"
    ref="modal"
    class="modal-container"
    content-class="modal-medium"
    title="パスワード変更"
  >
    <template v-slot:body="{ cancel }">
      <validation-observer v-slot="{ handleSubmit }" as="div">
        <v-form novalidate @submit.stop.prevent="handleSubmit(submit)">
          <div class="modal-body">
            <v-container>
              <v-row>
                <v-col>
                  <app-badge
                    item="現在のパスワード"
                    :isRequired="true"
                    :isInfo="false"
                  ></app-badge>
                  <validation-provider
                    label="現在のパスワード"
                    name="currentPassword"
                    :rules="{
                      required: true,
                      alpha_num_both: true,
                      between_length: { min: 8, max: 20 },
                    }"
                    v-model="form.currentPassword"
                    v-slot="{ componentField, errorMessage, meta }"
                  >
                    <app-form-input
                      type="password"
                      v-bind="componentField"
                      :error-messages="errorMessage"
                      :field-meta="meta"
                    />
                  </validation-provider>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <app-badge
                    item="新しいパスワード"
                    msg="・8文字以上20文字以内で、半角英字と数字を必ず１文字以上組み合わせてください。
                         ・ひとつ前のパスワードは設定できません。"
                    :isRequired="true"
                  ></app-badge>
                  <validation-provider
                    label="新しいパスワード"
                    name="newPassword"
                    :rules="{
                      required: true,
                      alpha_num_both: true,
                      between_length: { min: 8, max: 20 },
                    }"
                    v-model="form.newPassword"
                    v-slot="{ componentField, errorMessage, meta }"
                  >
                    <app-form-input
                      type="password"
                      v-bind="componentField"
                      :error-messages="errorMessage"
                      :field-meta="meta"
                    />
                  </validation-provider>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <app-badge
                    item="新しいパスワード(確認)"
                    :isRequired="true"
                    :isInfo="false"
                  ></app-badge>
                  <validation-provider
                    label="新しいパスワード(確認)"
                    name="confirmation"
                    :rules="{
                      required: true,
                      alpha_num_both: true,
                      between_length: { min: 8, max: 20 },
                      confirmed: {
                        target: '@newPassword',
                        targetField: '新しいパスワード',
                      },
                    }"
                    v-model="form.confirmation"
                    v-slot="{ componentField, errorMessage, meta }"
                  >
                    <app-form-input
                      type="password"
                      onpaste="return false"
                      v-bind="componentField"
                      :error-messages="errorMessage"
                      :field-meta="meta"
                    />
                  </validation-provider>
                </v-col>
              </v-row>
            </v-container>
          </div>

          <v-divider></v-divider>
          <!-- FOOTER -->
          <v-card-actions>
            <v-list-item class="w-100 pa-1">
              <template v-slot:append>
                <v-btn type="submit" variant="flat" color="primary">変更</v-btn>
                <v-btn variant="outlined" color="primary" @click="cancel">
                  キャンセル
                </v-btn>
              </template>
            </v-list-item>
          </v-card-actions>
        </v-form>
      </validation-observer>
    </template>
  </app-modal>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PutPassword } from "@/apis/PasswordApi";
import { VueFinalModal } from "vue-final-modal";

export default defineComponent({
  name: "PasswordModify",
  data() {
    return {
      form: {} as PutPassword,
    };
  },
  methods: {
    async submit() {
      await this.$confirm(`パスワードを変更します。よろしいですか？`);
      await this.$api.password.putPassword(this.form);
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
  },
});
</script>
